import TamplateLayoutScreen from '../HomeScreen/TampletLayout/TamplateLayoutScreen';
  
import {BrandSlider} from './BrandSlider';
import Carousel from './Carousel/Carousel';
import FeaturedCollection from './FeaturedCollection/FeaturedCollection';
import {NewArrivals} from './NewArrivals';
import OurStorySection from './ourStorySection/OurStorySection';
import TrendingCategories from './TrendingCategories/TrendingCategories';

const HomeScreen = () => {
  return (
    <div className={'flex flex-col items-center'}>  
      <Carousel /> 
      <TrendingCategories  data-aos={'fade-up'} />
      <FeaturedCollection  data-aos={'fade-up'} />
      <BrandSlider  data-aos={'fade-up'} />
      <OurStorySection  data-aos={'fade-up'} />
      <TamplateLayoutScreen />
      <NewArrivals className={'mb-12'}  data-aos={'fade-up'} />

      {/* Google Reviews Section */}
      <div className={'section mt-8 p-4'}>
        <script src={'https://elfsightcdn.com/platform.js'} async></script>
        <div className={'elfsight-app-ae6193ae-af54-4803-8e3c-4f84ce67acca'} data-elfsight-app-lazy></div>
      </div>
    </div>
  );
};

export default HomeScreen;
